import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';

import { createScoutProject } from '../../../redux/projects/projectsActions';
import validate from '../../../utils/validate';
import { createScoutProjectYopValidation } from '../validation';
import ScoutCreationForm from './ScoutCreationForm';

const ScoutCreation = () => {
  const dispatch = useDispatch();

  const createScoutProjectInitialValues = {
    projectName: '',
    assignUser: '',
    activeUsers: [],

    activeAllAssistants: [],
    activeSelectedAssistants: [],
    activeCompressAssistants: [],
  };

  const handleCreateProject = useCallback(
    (values) => {
      dispatch(createScoutProject(values));
    },
    [dispatch],
  );

  return (
    <Form
      initialValues={createScoutProjectInitialValues}
      onSubmit={handleCreateProject}
      validate={(values) => validate(values, createScoutProjectYopValidation())}
      subscription={{ submitting: true, pristine: true }}
      render={({ handleSubmit }) => <ScoutCreationForm handleSubmit={handleSubmit} />}
    />
  );
};

export default ScoutCreation;
